import {
    takeEvery, all, put, call,
} from 'redux-saga/effects';
import API from '../common/API';
import * as Actions from '../actions/RegistrationOrganizer';

function* getInformationXPAND(action) {
    const endpoint = `/api/v1/event/${action.payload}/info/`;
    try {
        const response = yield call(API.get, {
            endpoint: `${endpoint}`,
        });
        yield put(Actions.callApiGetInformationXPANDReceived(response));
    } catch (error) {
        yield put(Actions.callApiGetInformationXPANDReceivedFailure(yield error));
    }
}
function* getInformationRoom(action) {
    const endpoint = `/api/v1/seminar/${action.payload.shortName}/seminar_available/`;
    try {
        const response = yield call(API.get, {
            endpoint: `${endpoint}`,
            body: {
                date: action.payload.date,
                ...(action.payload.seminar_id && { seminar_id: action.payload.seminar_id }),
                ...(action.payload.language && { language: action.payload.language }),
            },
        });
        yield put(Actions.callApiGetInformationRoomReceived(response));
    } catch (error) {
        yield put(Actions.callApiGetInformationRoomReceivedFailure(yield error));
    }
}

function* createOrganizer(action) {
    const endpoint = action.payload?.language
        ? `/api/v1/user/organizer_register/?language=${action.payload.language}`
        : '/api/v1/user/organizer_register/';
    try {
        yield call(API.postWithFile, {
            endpoint: `${endpoint}`,
            body: action.payload,
        });
        yield put(Actions.callApiCreateOrganizerReceived());
    } catch (error) {
        yield put(Actions.callApiCreateOrganizerReceivedFailure(yield error));
    }
}

export default function* registrationOrganizer() {
    yield all([
        takeEvery('CALL_API_GET_INFORMATION_XPAND_ORGANIZER', getInformationXPAND),
        takeEvery('CALL_API_CREATE_ORGANIZER', createOrganizer),
        takeEvery('CALL_API_GET_INFORMATION_ROOM', getInformationRoom),
    ]);
}
